export default __webpack_public_path__ + "static/media/prabu-reading.7720cdd9.png";